import { render, staticRenderFns } from "./TasksBoard.vue?vue&type=template&id=13aaab7a&scoped=true&"
import script from "./TasksBoard.vue?vue&type=script&lang=ts&"
export * from "./TasksBoard.vue?vue&type=script&lang=ts&"
import style0 from "./TasksBoard.vue?vue&type=style&index=0&id=13aaab7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aaab7a",
  null
  
)

export default component.exports